import noop from 'lodash/noop';
import * as React from 'react';
const AccordionContext = React.createContext({
    activeId: '',
    onClick: noop,
});
export const useAccordion = () => React.useContext(AccordionContext);
export const AccordionProvider = (props) => {
    const [activeId, setActiveId] = React.useState(props.initialId ?? '');
    return (React.createElement(AccordionContext.Provider, { value: {
            activeId: activeId,
            onClick(id) {
                if (activeId === id) {
                    return setActiveId('');
                }
                setActiveId(id);
            },
        } }, props.children));
};
